import "./App.css";
import React, { useState } from "react";

function App() {
  const [intervalId, setIntervalId] = useState(0);
  const [isBreak, setIsBreak] = useState(false);
  const [firstTime, setFirstTime] = useState(true);
  const startTimer = () => {
    if (firstTime) {
      setSeconds(59);
      setMinutes((prev) => prev - 1);
    }

    setFirstTime(false);
    if (intervalId) {
      clearInterval(intervalId);
      setIntervalId(0);
      return;
    }

    const newIntervalId = setInterval(() => {
      setSeconds((prev) => prev - 1);
    }, 1000);
    setIntervalId(newIntervalId);
  };

  const [breakTime, setBreakTime] = useState(5);
  const [sessionTime, setSessionTime] = useState(25);
  const [seconds, setSeconds] = useState(60);
  const [minutes, setMinutes] = useState(25);

  if (seconds === 0) {
    setMinutes((prev) => prev - 1);
    setSeconds(59);
  }

  if (minutes === 0 && seconds === 0 && isBreak) {
    setIsBreak(false);
    setMinutes(sessionTime - 1);
    setSeconds(59);
    console.log("Session TIME");
  } else if (minutes === 0 && seconds === 0 && !isBreak) {
    setIsBreak(true);
    setMinutes(breakTime - 1);
    setSeconds(59);
    console.log("BREAK TIME");
  }

  const addBreak = () => {
    if (breakTime >= 60) return;
    setBreakTime((prev) => prev + 1);
  };

  const subBreak = () => {
    if (breakTime <= 1) return;
    setBreakTime((prev) => prev - 1);
  };

  const addSession = () => {
    if (sessionTime >= 60) return;
    setSessionTime((prev) => prev + 1);
    setMinutes((prev) => prev + 1);
  };

  const subSession = () => {
    if (sessionTime <= 1) return;

    setSessionTime((prev) => prev - 1);
    setMinutes((prev) => prev - 1);
  };

  const reset = () => {
    setIsBreak(false);
    setBreakTime(5);
    setSessionTime(25);
    setMinutes(25);
    setSeconds(60);
    setFirstTime(true);
    clearInterval(intervalId);
    setIntervalId(0);
  };

  return (
    <div className="App">
      <div className="divSettings">
        <div className="divInnerSettings">
          <p className="p" id="break-label">
            BREAK <span id="break-length">{breakTime}</span>
          </p>
          <button onClick={addBreak} id="break-increment">
            <span className="span">+</span>
          </button>
          <button onClick={subBreak} id="break-decrement">
            <span className="span">-</span>
          </button>
        </div>
        <div className="divInnerSettings">
          <p className="p" id="session-label">
            SESSION <span id="session-length">{sessionTime}</span>
          </p>
          <button onClick={addSession} id="session-increment">
            <span className="span">+</span>
          </button>
          <button onClick={subSession} id="session-decrement">
            <span className="span">-</span>
          </button>
        </div>
      </div>
      <div className="divSettings">
        <p className="feedback" id="timer-label">
          CLOCK: {isBreak ? "BREAK" : "WORK"}
        </p>
        <p className="time" id="time-left">
          {minutes < 10 ? `0${minutes}` : minutes}:
          {seconds === 60 ? "00" : seconds < 10 ? `0${seconds}` : seconds}
        </p>
        <div className="btnBox">
          <button id="start_stop" onClick={startTimer}>
            {intervalId ? "Stop" : "Start"}
          </button>
          <button onClick={reset} id="reset">
            RESET
          </button>
        </div>
      </div>
    </div>
  );
}

export default App;
